import type { ClientEscrowPlanSummaryDto } from '@paladin-monorepo/common';
import API from '../api';

export const clientEscrowApi = {
  listPlans(): Promise<ClientEscrowPlanSummaryDto[]> {
    return API.get<ClientEscrowPlanSummaryDto[]>('/client/escrow-plans').then((r) => r.data);
  },

  freeze(paymentPlanId: string): Promise<{ ok: true }> {
    return API.post<{ ok: true }>(
      `/client/payment-plans/${encodeURIComponent(paymentPlanId)}/escrow/freeze`,
      {},
    ).then((r) => r.data);
  },

  unfreeze(paymentPlanId: string): Promise<{ ok: true }> {
    return API.post<{ ok: true }>(
      `/client/payment-plans/${encodeURIComponent(paymentPlanId)}/escrow/unfreeze`,
      {},
    ).then((r) => r.data);
  },
};
